import { store } from 'expo-router/build/global-state/router-store';

let lastPathname = '';
let previousPathname = '';

export const getStaticPathname = () => {
  const pathname = store?.routeInfo?.pathname as string;
  if (pathname && pathname !== lastPathname) {
    previousPathname = lastPathname;
    lastPathname = pathname;
  }
  return pathname;
};

export const getStaticPathAndSearch = () => store?.routeInfo?.unstable_globalHref;

export const getStaticReferrerPathname = () => previousPathname;
